var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "top",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("basicData.CopyModule"), prop: "model" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: _vm.$t("GlobalSetObj.pleaseChoose") },
                  model: {
                    value: _vm.form.model,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "model", $$v)
                    },
                    expression: "form.model",
                  },
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("basicData.BasicRules"),
                      value: "1",
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("basicData.otherRules"),
                      value: "2",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "btn-group" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.submit },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }